<!-- 查看实训案例 -->
<template>
  <div class="el-trainingIndex" style="padding: 20px 20px 0;">
    <el-row class="content_block mb20">
      <TitleInfo title="查看实训案例" :titleImg="caozuo"></TitleInfo>
      <el-row class="p20">
        <el-row>
          <el-button :class="onIndex ==0?'check':''" plain @click="checkTask({},0)">案例介绍</el-button>
          <template v-for="(item ,index) in taskList">
            <el-button :class="onIndex ==(index + 1)?'check':''" plain @click="checkTask(item,index + 1)">任务{{index + 1}}</el-button>
          </template>
          <template v-if='examType == 2'>
            <span class="fontB" style="color: red;padding: 10px 30px;margin-left: 100px;">合计得分：{{sumScore || 0}} 分</span>
          </template>
          <el-button type="danger" icon="el-icon-tickets" style="float: right;" @click="dialogVisible(2)">知识点</el-button>

        </el-row>
      </el-row>
      <template v-if="onIndex == 0">
        <el-row style="border: 1px solid #D3D3D3;margin: 0 20px 20px 20px;padding: 0 20px 20px 20px;min-height: calc(100vh - 280px);">
          <p class="fontB"><i class="el-icon-document-remove icon_"></i>案例名称：</p>
          <p>{{indexInfo.handsOnName}}</p>
          <p class="fontB"><i class="el-icon-document icon_"></i>案例介绍：</p>
          <el-row class="aljj">
            <el-row v-html="indexInfo.handsOnRecommend"></el-row>
          </el-row>
        </el-row>
      </template>
      <Task1 v-if="onTaskInfo.taskType == 1" :key="onIndex" :scoreInfo="scoreInfo[onTaskInfo.taskId]" :taskId="onTaskInfo.taskId" :handsOnId="handsOnId" :courseId="teacherOpenCourseId" :examType="Number(examType)" :courseType="Number(courseType)"></Task1>
      <Task2 v-if="onTaskInfo.taskType == 2" :key="onIndex" :scoreInfo="scoreInfo[onTaskInfo.taskId]" :taskId="onTaskInfo.taskId" :handsOnId="handsOnId" :courseId="teacherOpenCourseId" :examType="Number(examType)" :courseType="Number(courseType)"></Task2>
      <Task3 v-if="onTaskInfo.taskType == 3" :key="onIndex" :scoreInfo="scoreInfo[onTaskInfo.taskId]" :taskId="onTaskInfo.taskId" :handsOnId="handsOnId" :courseId="teacherOpenCourseId" :examType="Number(examType)" :courseType="Number(courseType)"></Task3>
      <Task4 v-if="onTaskInfo.taskType == 4" :key="onIndex" :scoreInfo="scoreInfo[onTaskInfo.taskId]" :taskId="onTaskInfo.taskId" :handsOnId="handsOnId" :courseId="teacherOpenCourseId" :examType="Number(examType)" :courseType="Number(courseType)"></Task4>
      <Task5 v-if="onTaskInfo.taskType == 5" :key="onIndex" :scoreInfo="scoreInfo[onTaskInfo.taskId]" :taskId="onTaskInfo.taskId" :handsOnId="handsOnId" :courseId="teacherOpenCourseId" :examType="Number(examType)" :courseType="Number(courseType)"></Task5>
    </el-row>

    <!-- 知识点查看对话框 -->
    <el-dialog
      :visible.sync="show_points"
      class="points_class_dialog"
      width="800px">
      <span slot="title" class="dialog-footer" style="font-weight: bold;">
        <el-image style="width: 22px;float: left;margin-right: 10px;" :src="zhisdian"></el-image>
        查看知识点
      </span>
      <el-row style="height: 400px;">
        <el-col :span="6" class="left_box">
          <div style="border:1px solid #D3D3D3;margin-right:20px">
            <p class="m0 p10 tc fontB" style="background-color: #EFF2F7;">知识点名称</p>
            <ul>
              <template v-for="(item,index) in KnowledgePointList">
                <li :class="index == onKnowledgePoint?'on':''" @click="seeKnowledgePoint(item,index)">{{item.knowledgePointTitle}}</li>
              </template>
            </ul>
          </div>
        </el-col>
        <el-col :span="18" class="rigth_box">
          <el-row style="border:1px solid #D3D3D3;height: 380px;padding: 10px;line-height: 30px;overflow: auto;">
            <el-row>
              <el-col :span="12" class="fontB">
                <el-image style="width: 22px;float: left;margin-right: 10px;margin-top: 4px;" :src="cont"></el-image>
                知识点内容
              </el-col>
              <!-- <el-col :span="12" class="t_r">
                <el-button size="small"  plain v-if="!$isEmpty(knowledgePointInfo.knowledgePointContent)">
                  <el-image class="but_exercises_img" :src="shouc"></el-image>
                  收藏
                </el-button>
              </el-col> -->
            </el-row>
            <el-row>
              <el-row v-html="knowledgePointInfo.knowledgePointContent">

              </el-row>
            </el-row>
          </el-row>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import TitleInfo from "@/components/TitleInfo";	//页面头部
import Task1 from "./components/PracticalTraining/Task1";	//任务1
import Task2 from "./components/PracticalTraining/Task2";	//任务2
import Task3 from "./components/PracticalTraining/Task3";	//任务3
import Task4 from "./components/PracticalTraining/Task4";	//任务4
import Task5 from "./components/PracticalTraining/Task5";	//任务5
import {getBindingKnowledgePoint} from "@/common/getInfo";	//公共方法
export default {
  name: "TrainingIndex",
  components: {
  	TitleInfo,
  	Task1,
  	Task2,
  	Task3,
  	Task4,
  	Task5,
  },
  data() {
    return {
      caozuo:require("../../images/course/caozuo@2x.png"),
      onIndex:0,
      examType:this.$route.query.examType, //查看类型
      chapterId:this.$route.query.chapterId, //知识点ID
      handsOnId:this.$route.query.handsOnId, //实训ID
      teacherOpenCourseId:this.$route.query.courseId, //课程ID
      courseType:this.$route.query.courseType, //课程类型 1：开课 2：授权课
      teacherOpenCourseMergeCourseInfoId:this.$route.query.mergeCourseId, //课程ID
      indexInfo:{},
      taskList:[],
      onTaskInfo:{}, //当前选中的任务信息
      scoreInfo:{}, //根据任务ID存入map{}
      sumScore:0, //总分
      cont:require("../../images/course/cont@2x.png"),
      zhisdian:require("../../images/course/zhisdian@2x.png"),
      shouc:require("../../images/course/shouc@2x_1.png"),
      shouc_b:require("../../images/course/shouc@2x_2.png"),
      show_points: false, //知识点查看对话框
      KnowledgePointList:[], //知识点List
      knowledgePointInfo:{},
      courseInfoName:this.$route.query.courseInfoName, //课程名称
      timeNum:null
    };
  },
  created() {
    this.getInfo();
    this.getTaskList();
    //this.addSystem();
    if(this.examType == 2){
      this.$get("/api/teacherOpenCourseHandsOnSimulationTasks/getCourseCentreScoreTask",{handsOnId:this.handsOnId,courseType:this.courseType}).then((ret) =>{
        if(ret.code == 0){
          this.sumScore = ret.data.sumScore;
          if(ret.data.handsOnTaskScores.length > 0){
            for(let item of ret.data.handsOnTaskScores){
              this.scoreInfo[item.handsOnTaskId] = item;
            }
          }
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    }
  },
  mounted() {

  },
  methods: {
    getInfo(){
      let url = "/api/teacherOpenCourseHandsOn/getInfo.do";
      if(this.courseType == 2){
        url = "/api/handsOn/getInfo.do";
      }
      this.$get(url,{handsOnId:this.handsOnId}).then((ret) =>{
        if(ret.code == 0){
          this.indexInfo = ret.data;
          this.getKnowledgePoint();
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    startExam(item){
      this.$router.push({name:'CoachExam',query:{type:1}});
    },
    resultDetails(item){ //查看错题
      this.$router.push({name:'CoachExam',query:{type:2}});
    },
    checkTask(item,index){ //切换任务
      this.onIndex = index;
      this.onTaskInfo = item;
    },
    getTaskList(){ //任务List查看
      let url = "/api/teacherOpenCourseHandsOnSimulationTasks/getPageList.do";
      if(this.courseType == 2){
        url = "/api/handsOnSimulationTasks/getPageList.do";
      }
      this.$post(url,{handsOnId:this.handsOnId}).then((ret) =>{
        if(ret.code == 0){
          this.taskList = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    dialogVisible(){ //知识点查看
      if(this.KnowledgePointList.length <= 0){
        this.$message.warning("暂无知识点信息！");
        return;
      }
      this.show_points = true;
    },
    collection(item){ //收藏或者取消收藏
      let param = {
        questionSettingId:item.teacherOpenCourseQuestionSettingId,
        questionSnapIds:item.resourcesQuestionSnapshotId,
        isTuck:true
      }
      this.$post("/api/teacherOpenCourseQuestionLog/tuck.do",param).then((ret) =>{
        if(ret.code == 0){
          this.$message.success('收藏成功!');
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    getKnowledgePoint(){ //获取知识点
      if(!this.$isEmpty(this.chapterId)){
        let param = {
          teacherOpenCourseId:this.teacherOpenCourseId,
          handsOnId:this.handsOnId,
          chapterId:this.chapterId,
          bussinessId: this.handsOnId,
          bussinessType: 2
        }
        getBindingKnowledgePoint(param).then((ret) =>{
          if(ret.code == 0){
            this.KnowledgePointList = ret.data;
            if(ret.data != null && ret.data.length > 0){
              this.knowledgePointInfo = ret.data[0];
              this.onKnowledgePoint = 0;
            }
          }else{
            this.$message({message: ret.msg,type: 'error'});
          }
        });
      }
    },
    seeKnowledgePoint(item,i){ //查看知识点
      this.knowledgePointInfo = item;
      this.onKnowledgePoint = i;
    },
    addSystem(){ //模块使用统计
      //模块使用时间 开始
      const timeNum = this.$ls.get('timeNum'); //获取统一
      this.timeIn = setInterval(()=>{
        let param = {
          firstName:"课程中心",//一级名称
          secondName:this.courseInfoName,//二级名称
          useDuration:timeNum / 1000 / 60//单次使用时长（单位：分钟）
        }
        this.$addSystemUseLog(param);
      },timeNum);
      // 结束
    }
  },
  beforeDestroy() {
    clearInterval(this.timeIn); //关闭定时
  }
};
</script>
 <style  lang="less">
  .el-trainingIndex{
    // min-height: calc(100vh - 120px);
    .content_block{
      min-height: calc(100vh - 140px);
      background-color: #ffffff;
      .el-divider--horizontal{
        margin: 0;
      }
    }

    .but_exercises_img{
      width: 20px;
      height: 20px;
      float: left;
      margin-right:5px;
    }

    .icon_{
      color: #2789E2;margin-right: 10px;
    }
    .check{
      color: #2789E2;
      border-color:#2789E2 ;
    }
    .aljj{
      p{
        margin: 0;
        line-height: 30px;
        // text-indent: 2em;
      }
    }
    .points_class_dialog{
      ul{
        list-style-type:none;
        margin: 0;
        padding: 10px;
        height: 320px;
        overflow: auto;
      }
      li{
        line-height: 30px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
         /*! autoprefixer: off */
         -webkit-box-orient: vertical;
         /* autoprefixer: on */
         cursor: pointer;
      }
      .on{
        color: #2789E2;
      }
      .el-dialog__header{
        border-bottom: 1px solid #D3D3D3;
      }
      .rigth_box{
        p{
          margin: 0 !important;
        }
      }
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/lookCourse/TrainingIndex.vue